export default function () {
    return window.innerWidth < 450;
}
